module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Tabs"
  }, [_c('div', {
    staticClass: "Tabs-header u-mt4"
  }, [_c('div', {
    staticClass: "l-wrap--medium"
  }, [(_vm.tabs.length > 1) ? _c('ul', {
    staticClass: "Tabs-menu"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "Tabs-menu-item"
    }, [_c('a', {
      staticClass: "Tabs-menu-link",
      class: {
        '-active': tab.isActive
      },
      attrs: {
        "href": tab.href
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.name) + "\n          ")])])
  })) : _vm._e()])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077a1d23","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/tabs.vue
// module id = 317
// module chunks = 0